import {
  Bot,
  CalendarClock,
  Cpu,
  Globe,
  GraduationCap,
  MessageSquareText,
  Store,
  Users,
  Wrench,
} from "lucide-react";
import type { LucideIcon, LucideProps } from "lucide-react";
import { createElement } from "react";

/* One icon per course, shared by the hub's cards and the courses popover so a
   course looks the same wherever it is listed. Unlisted slugs fall back to the
   wrench. */
const courseIcons: Record<string, LucideIcon> = {
  "how-ai-agents-work": Cpu,
  "get-better-answers": MessageSquareText,
  "first-assistant": Bot,
  workflows: CalendarClock,
  "website-assistant": Globe,
  "sell-your-assistant": Store,
  "expertise-to-assistant": GraduationCap,
  team: Users,
};

export function courseIcon(slug: string): LucideIcon {
  return courseIcons[slug] ?? Wrench;
}

/* The icon as a component, so render code can use it without picking a
   component type mid-render. */
export function CourseIcon({ slug, ...props }: { slug: string } & LucideProps) {
  return createElement(courseIcon(slug), props);
}
